import {HttpClient} from './httpClient' 
import {API_URL} from './RestAPI'
import apiHeaders from './apiHeaders'
import {setUrlForGetRequest} from './sharedFunctions'

//Setting the categories URI
const Collection_API = `${API_URL}/collections`
const PRODUCT_COLLECTION_API = `${API_URL}/collection`

// Create
const createCollection = (collection, storeId) => {
  const url = storeId ? `${Collection_API}/create?store_id=${storeId}` : `${Collection_API}/create`;
  return HttpClient.post(url, collection, apiHeaders());
}

// Read
const getCollections = (params, dependent = {}) => {
  let url = setUrlForGetRequest(Collection_API, params)
  return HttpClient.get(url, apiHeaders(dependent))
}

// Get
const getCollection = id => {
  return HttpClient.get(
    `${Collection_API}/${id}`,
    apiHeaders()
  )
}

// Update
const updateCollection = (id, collection, storeId) => {
  const url = storeId ? `${Collection_API}/${id}/update?store_id=${storeId}` : `${Collection_API}/${id}/update`;
  return HttpClient.put(url, collection, apiHeaders());
}

// Delete
const removeCollection = (collection, storeId) => {
  const url = storeId ? `${Collection_API}/${collection.id}?store_id=${storeId}` : `${Collection_API}/${collection.id}`;
  return HttpClient.delete(url, apiHeaders());
}

const searchCollections = (q, page=0, storeId) => {
  return HttpClient.get(
    `${Collection_API}?q=${q}&page=${page}&store_id=${storeId}`,
    apiHeaders()
  )
}

const addProductsToCollection = (body) => {
  return HttpClient.post(
    `${PRODUCT_COLLECTION_API}/addProducts`,
    body,
    apiHeaders()
  )
}

//Encapsulating in a JSON object
const CollectionApi = {getCollections, createCollection, getCollection, updateCollection, removeCollection, searchCollections,addProductsToCollection}

export {CollectionApi}